module.exports = __webpack_public_path__ + "static/media/logo_200___.b175e1c4.png";